/* Quick-add behaviour for the default-quick-add collection template.
   Loaded only on that template. Event-delegated so it works with the
   theme's AJAX pagination / filtering (cards added after load). */
(function () {
  'use strict';

  var ADDED_MS = 1600;

  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function getVariants(qa) {
    // Prefer our own variant data, rendered with `| json | escape` so it stays
    // valid inside the double-quoted attribute. The theme's data-json-product is
    // single-quoted and breaks whenever media/variant text contains an
    // apostrophe (e.g. an alt like "Tsuki 'Winter Wishes'"), which truncated the
    // JSON and made every option look unavailable.
    var own = qa.getAttribute('data-nt-variants');
    if (own) {
      try { return JSON.parse(own) || []; } catch (e) { /* fall through */ }
    }
    var host = closest(qa, '[data-json-product]');
    if (host) {
      try { return JSON.parse(host.getAttribute('data-json-product')).variants || []; } catch (e) { /* ignore */ }
    }
    return [];
  }

  // Current selection as an array indexed by option position (null = unset).
  function getSelection(panel) {
    var sel = [];
    panel.querySelectorAll('[data-nt-qa-option-index]').forEach(function (opt) {
      var idx = parseInt(opt.getAttribute('data-nt-qa-option-index'), 10);
      var active = opt.querySelector('.nt-quick-add__value.is-selected');
      sel[idx] = active ? active.getAttribute('data-value') : null;
    });
    return sel;
  }

  function variantMatches(variant, selection) {
    for (var i = 0; i < selection.length; i++) {
      if (selection[i] != null && variant.options[i] !== selection[i]) return false;
    }
    return true;
  }

  function findVariant(variants, selection) {
    for (var i = 0; i < selection.length; i++) {
      if (selection[i] == null) return null; // not fully selected
    }
    for (var j = 0; j < variants.length; j++) {
      if (variantMatches(variants[j], selection)) return variants[j];
    }
    return null;
  }

  // Disable option values that can't form any available variant given the
  // current selection of the *other* options.
  function refresh(qa) {
    var panel = qa.querySelector('[data-nt-qa-panel]');
    if (!panel) return;
    var variants = getVariants(qa);
    var selection = getSelection(panel);

    panel.querySelectorAll('[data-nt-qa-option-index]').forEach(function (opt) {
      var idx = parseInt(opt.getAttribute('data-nt-qa-option-index'), 10);
      opt.querySelectorAll('.nt-quick-add__value').forEach(function (btn) {
        var test = selection.slice();
        test[idx] = btn.getAttribute('data-value');
        var ok = variants.some(function (v) {
          return v.available && variantMatches(v, test);
        });
        btn.disabled = !ok;
        btn.classList.toggle('is-unavailable', !ok);
        if (!ok) btn.classList.remove('is-selected');
      });
    });
  }

  function closeAllPanels(except) {
    document.querySelectorAll('.nt-quick-add.is-open').forEach(function (qa) {
      if (qa !== except) qa.classList.remove('is-open');
    });
  }

  function flashAdded(qa) {
    qa.classList.remove('is-loading');
    qa.classList.add('is-added');
    setTimeout(function () { qa.classList.remove('is-added'); }, ADDED_MS);
  }

  function updateCartCountFallback(root) {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function addToCart(qa, variantId) {
    if (!variantId) return;
    qa.classList.add('is-loading');
    var handle = qa.getAttribute('data-product-handle');

    // Prefer the theme's own AJAX add — it refreshes the header cart count
    // and drawer contents without opening the drawer.
    if (window.ella && typeof window.ella.doAjaxAddToCart === 'function') {
      try {
        window.ella.doAjaxAddToCart({ id: variantId, quantity: 1 }, handle);
        flashAdded(qa);
        return;
      } catch (e) { /* fall through to fetch */ }
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { updateCartCountFallback(root); flashAdded(qa); })
      .catch(function () { qa.classList.remove('is-loading'); });
  }

  // --- delegated events ---
  document.addEventListener('click', function (e) {
    var valueBtn = closest(e.target, '.nt-quick-add__value');
    if (valueBtn) {
      if (valueBtn.disabled) return;
      var optRow = closest(valueBtn, '[data-nt-qa-option-index]');
      optRow.querySelectorAll('.nt-quick-add__value').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      valueBtn.classList.add('is-selected');
      var qaV = closest(valueBtn, '[data-nt-quick-add]');
      refresh(qaV);
      // Auto-add as soon as a complete, available variant is selected.
      // For multi-option products this only fires once every option is chosen.
      var panel = qaV.querySelector('[data-nt-qa-panel]');
      var match = findVariant(getVariants(qaV), getSelection(panel));
      if (match && match.available) {
        addToCart(qaV, match.id);
        qaV.classList.remove('is-open');
      }
      return;
    }

    var icon = closest(e.target, '[data-nt-qa-icon]');
    if (icon) {
      var qa = closest(icon, '[data-nt-quick-add]');
      var variantId = icon.getAttribute('data-nt-variant-id');
      if (variantId) {
        // Single-variant product: add straight away.
        addToCart(qa, variantId);
      } else {
        // Multi-variant: toggle the options panel.
        var willOpen = !qa.classList.contains('is-open');
        closeAllPanels(qa);
        qa.classList.toggle('is-open', willOpen);
        if (willOpen) refresh(qa);
      }
      return;
    }

    // Click outside any panel closes open panels.
    if (!closest(e.target, '.nt-quick-add')) closeAllPanels(null);
  });
})();
